<template>
  <GuDialog v-model:open="isConfirmationDialogOpen">
    <GuDialogTrigger as-child>
      <div v-if="hasAccessLevel" class="form-check form-switch">
        <GuSwitch id="toggleMemberAccessSwitch" :checked="accessLevelFlag" />
        <GuLabel class="form-check-label" for="toggleMemberAccessSwitch">
          {{ accessLevelFlag ? 'All' : 'Personal' }}
        </GuLabel>
      </div>
    </GuDialogTrigger>

    <GuDialogContent>
      <template #title>
        <h5 class="modal-title fs-18">Disable Company</h5>
      </template>

      <p>Are you sure you want to change the application access level for <strong>user</strong> to <span class="text-danger">something</span>?</p>

      <template #footer>
        <GuDialogClose as-child>
          <GuButton
            variant="secondary"
            :disabled="actionInProgress"
          >
            Cancel
          </GuButton>
        </GuDialogClose>

        <GuButton
          :loading="actionInProgress"
          @click="triggerAction"
        >
          Confirm
        </GuButton>
      </template>
    </GuDialogContent>
  </GuDialog>
</template>

<script setup>
import { computed, onBeforeMount, ref, toRefs } from 'vue'

import { GuButton } from '@shared/gu-components/button'
import { GuDialog, GuDialogClose, GuDialogContent, GuDialogTrigger } from '@shared/gu-components/dialog'
import { GuLabel } from '@shared/gu-components/label'
import { GuSwitch } from '@shared/gu-components/switch'
import { useToast } from '@shared/gu-components/toast'

import { toggleApplicationAccess } from '@companies/api/companies.api'

const ACCESS_LEVELS = ['ALL', 'PERSONAL']

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)

const { toast } = useToast()

const actionInProgress = ref(false)
const isConfirmationDialogOpen = ref(false)

const hasAccessLevel = computed(() => ACCESS_LEVELS.includes(accessLevel.value))

const accessLevel = ref(params.value.data.applicationAssociation)
const accessLevelFlag = computed(() => accessLevel.value === 'ALL')

const companyName = ref(props.params.companyName || '')

onBeforeMount(() => {
  accessLevel.value = params.value.data.applicationAssociation
})

const { mutateAsync: toggleApplicationAccessMutation } = toggleApplicationAccess(companyName.value, params.value.data.name)

async function triggerAction () {
  actionInProgress.value = true

  const POSSIBLE_VALUES = {
    ALL: 'ALL',
    All: 'ALL',
    PERSONAL: 'PERSONAL',
    Personal: 'PERSONAL',
  }

  try {
    const payload = {
      companyName: companyName.value,
      userName: params.value.data.name,
      rowId: params.value.data.id,
    }

    const response = await toggleApplicationAccessMutation(payload)

    accessLevel.value = POSSIBLE_VALUES[response.newValue]
    isConfirmationDialogOpen.value = false
  } catch (ex) {
    console.error(ex)

    toast({
      variant: 'danger',
      description: ex.details || ex.message,
    })
  } finally {
    actionInProgress.value = false
  }
}
</script>
